<div class="bill-page">

    <!-- Fejléc -->
    <div class="bill-head">
        <div class="bill-head__titles">
            <div class="bill-head__title-row">
                <h1 class="stk-page-title">Számlázás</h1>
                <span
                    class="bill-missing-chip"
                    *ngIf="!loadFailed"
                    [class.bill-missing-chip--ok]="missingCount === 0"
                >{{missingChipLabel}}</span>
            </div>
            <div class="stk-page-sub">Minden beérkezett rendelés, egy helyen — ellenőrizd, hogy mindenhez készült-e számla.</div>
        </div>
        <div class="bill-head__actions">
            <button type="button" class="bill-audit-btn" (click)="toggleAudit()">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4 H6 a1 1 0 0 0 -1 1 v15 a1 1 0 0 0 1 1 h12 a1 1 0 0 0 1 -1 V5 a1 1 0 0 0 -1 -1 h-3"></path><rect x="9" y="2.5" width="6" height="3.5" rx="1"></rect><polyline points="9,13 11,15 15,10.5"></polyline></svg>
                Teljes ellenőrzés
            </button>
            <button
                type="button"
                class="bill-bulk"
                [class.bill-bulk--on]="selMissing > 0 && !bulkCreating"
                [disabled]="selMissing === 0 || bulkCreating"
                (click)="bulkCreate()"
            >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
                {{bulkCreating ? 'Számlák létrehozása…' : bulkLabel}}
            </button>
        </div>
    </div>

    <!-- Teljes körű ellenőrzés: MINDEN rendelésre, a képernyő szűrőitől
         függetlenül — ebből derül ki, hol hiányzik számla a múltban. -->
    <div class="bill-audit" *ngIf="auditOpen">
        <div class="bill-audit__head">
            <h3 class="bill-audit__title">Teljes körű számla-ellenőrzés</h3>
            <button type="button" class="bill-audit__refresh" [disabled]="auditLoading" (click)="runAudit()">
                {{ auditLoading ? 'Ellenőrzés…' : 'Újraellenőrzés' }}
            </button>
        </div>

        <div class="bill-audit__loading" *ngIf="auditLoading && !audit">Az összes rendelés ellenőrzése folyamatban…</div>

        <ng-container *ngIf="audit as a">
            <div class="bill-audit__tiles">
                <div class="bill-audit__tile">
                    <div class="bill-audit__tile-num">{{ a.total }}</div>
                    <div class="bill-audit__tile-label">rendelés összesen</div>
                </div>
                <div class="bill-audit__tile bill-audit__tile--ok">
                    <div class="bill-audit__tile-num">{{ a.invoiced }}</div>
                    <div class="bill-audit__tile-label">van élő számla</div>
                </div>
                <div class="bill-audit__tile bill-audit__tile--storno">
                    <div class="bill-audit__tile-num">{{ a.cancelled }}</div>
                    <div class="bill-audit__tile-label">sztornózva</div>
                </div>
                <div class="bill-audit__tile" [class.bill-audit__tile--warn]="a.missing > 0">
                    <div class="bill-audit__tile-num">{{ a.missing }}</div>
                    <div class="bill-audit__tile-label">hiányzik</div>
                </div>
            </div>

            <div class="bill-audit__providers">
                Számlázó szerinti megoszlás:
                <strong>{{ a.byProvider.okoskonyvelom }}</strong> Okos Könyvelőm ·
                <strong>{{ a.byProvider.billingo }}</strong> Billingo (régi)
            </div>

            <div class="bill-audit__cols">
                <div class="bill-audit__col">
                    <div class="bill-audit__col-title">Forrás szerint</div>
                    <div class="bill-audit__line" *ngFor="let s of a.bySource">
                        <span class="bill-audit__line-name">{{ s.source }}</span>
                        <span class="bill-audit__line-val">{{ s.invoiced }} / {{ s.total }}</span>
                        <span class="bill-audit__line-miss" *ngIf="s.missing > 0">{{ s.missing }} hiányzik</span>
                    </div>
                </div>
                <div class="bill-audit__col">
                    <div class="bill-audit__col-title">Hiányzó számlák hónap szerint</div>
                    <div class="bill-audit__empty" *ngIf="!a.byMonth.length">Nincs hiányzó számla.</div>
                    <button type="button" class="bill-audit__line bill-audit__line--click"
                            *ngFor="let m of a.byMonth" (click)="showMissingFromAudit(m.month)">
                        <span class="bill-audit__line-name">{{ auditMonthLabel(m.month) }}</span>
                        <span class="bill-audit__line-val">{{ m.total }} rendelés</span>
                        <span class="bill-audit__line-miss">{{ m.missing }} hiányzik</span>
                    </button>
                </div>
            </div>

            <div class="bill-audit__foot">
                <button type="button" class="bill-audit__all" *ngIf="a.missing > 0" (click)="showMissingFromAudit()">
                    Összes hiányzó megnyitása a listában
                </button>
                <span class="bill-audit__note" *ngIf="a.missingSampleTruncated">
                    A hiánylista első 500 tétele látszik a részletes nézetben.
                </span>
                <span class="bill-audit__note" *ngIf="a.missing === 0">
                    Minden rendeléshez tartozik számla — az új számlázó tiszta állapotból indulhat.
                </span>
            </div>
        </ng-container>
    </div>

    <!-- Szűrősor -->
    <div class="bill-filters">
        <div class="bill-search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
            <input
                type="text"
                [formControl]="searchCtrl"
                placeholder="Keresés név vagy rendelés ID…"
                size="4"
            >
        </div>
        <div class="bill-chip-group">
            <button
                type="button"
                *ngFor="let c of sourceChips"
                class="bill-chip"
                [class.is-active]="sourceFilter === c"
                (click)="setSourceFilter(c)"
            >{{c}}</button>
        </div>
        <div class="bill-chip-group">
            <button
                type="button"
                *ngFor="let c of statusChips"
                class="bill-chip"
                [class.is-active]="statusFilter === c"
                (click)="setStatusFilter(c)"
            >{{c}}</button>
        </div>
        <div class="bill-chip-group">
            <button
                type="button"
                *ngFor="let c of dateChips"
                class="bill-chip"
                [class.is-active]="!customRangeActive && dateFilter === c"
                (click)="setDateFilter(c)"
            >{{c}}</button>
        </div>

        <!-- Egyedi dátum-tartomány (naptárból, pl. dec 21 – jan 31) -->
        <div class="bill-daterange" [class.is-active]="customRangeActive">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="16" y1="3" x2="16" y2="7"></line></svg>
            <input type="date" class="bill-date__input" [value]="dateInputValue('from')" (change)="onDateInput('from', $event)" aria-label="Kezdő dátum">
            <span class="bill-date__dash">–</span>
            <input type="date" class="bill-date__input" [value]="dateInputValue('to')" (change)="onDateInput('to', $event)" aria-label="Záró dátum">
            <button *ngIf="customRangeActive" type="button" class="bill-date__clear" title="Tartomány törlése" (click)="clearCustomRange()">×</button>
        </div>
    </div>

    <!-- Táblázat -->
    <div class="bill-table" [class.bill-table--loading]="fetching">
        <div class="bill-grid bill-thead">
            <div
                class="bill-check"
                [class.is-on]="allSelected"
                role="checkbox"
                [attr.aria-checked]="allSelected"
                aria-label="Összes kijelölése"
                (click)="toggleAll()"
            >
                <svg *ngIf="allSelected" width="12" height="12" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#2E3A1F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
            </div>
            <div class="bill-th">Forrás</div>
            <div class="bill-th">Vevő</div>
            <div class="bill-th">Rendelés</div>
            <div class="bill-th">Dátum</div>
            <div class="bill-th">Összeg</div>
            <div class="bill-th">Számla</div>
            <div class="bill-th bill-th--right">Művelet</div>
        </div>

        <div
            class="bill-grid bill-row"
            *ngFor="let r of visibleRows; trackBy: trackByRowId"
            [class.is-selected]="sel[r.id]"
        >
            <div
                class="bill-check"
                [class.is-on]="sel[r.id]"
                role="checkbox"
                [attr.aria-checked]="!!sel[r.id]"
                aria-label="Rendelés kijelölése"
                (click)="toggleSel(r)"
            >
                <svg *ngIf="sel[r.id]" width="12" height="12" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#2E3A1F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
            </div>
            <div class="bill-src">
                <div class="bill-src__badge" [style.background]="r.srcColor">{{r.srcInitial}}</div>
                <span class="bill-src__name">{{r.src}}</span>
            </div>
            <div class="bill-name">{{r.name}}</div>
            <div class="bill-dim bill-dim--id">{{r.idLabel}}</div>
            <div class="bill-dim bill-dim--date">{{r.dateLabel}}</div>
            <div class="bill-amt">{{r.amtLabel}}</div>
            <div class="bill-stcell"><span class="bill-st" [ngClass]="r.stClass">{{r.stLabel}}</span></div>
            <div class="bill-actions">
                <button
                    *ngIf="r.canCreate"
                    type="button"
                    class="bill-act bill-act--ok"
                    title="Számla létrehozása"
                    [disabled]="isRowLoading(r) || bulkCreating"
                    (click)="createInvoice(r)"
                >+</button>
                <button
                    *ngIf="r.canDownload"
                    type="button"
                    class="bill-act bill-act--ok"
                    title="Számla letöltése (PDF)"
                    (click)="downloadInvoice(r)"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="4" x2="12" y2="15"></line><polyline points="7,10 12,15 17,10"></polyline><line x1="5" y1="20" x2="19" y2="20"></line></svg>
                </button>
                <button
                    *ngIf="r.canRegen"
                    type="button"
                    class="bill-act bill-act--ok"
                    title="Számla újragenerálása"
                    [disabled]="isRowLoading(r) || bulkCreating"
                    (click)="regenInvoice(r)"
                >⟳</button>
                <button
                    *ngIf="r.canStorno"
                    type="button"
                    class="bill-act bill-act--danger"
                    title="Számla sztornózása"
                    [disabled]="isRowLoading(r) || bulkCreating"
                    (click)="cancelInvoice(r)"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"></circle><line x1="6.5" y1="6.5" x2="17.5" y2="17.5"></line></svg>
                </button>
            </div>
        </div>

        <div class="bill-empty" *ngIf="fetching && visibleRows.length === 0">Rendelések betöltése…</div>
        <div class="bill-empty" *ngIf="!fetching && loadFailed">
            Nem sikerült betölteni a rendeléseket.
            <button type="button" class="bill-retry" (click)="fetchOrders()">Újrapróbálás</button>
        </div>
        <div class="bill-empty" *ngIf="!fetching && !loadFailed && visibleRows.length === 0">Nincs a szűrésnek megfelelő rendelés.</div>
    </div>

    <div class="bill-foot">
        <span>{{footerLabel}}</span>
        <span class="bill-pager" *ngIf="pageCount > 1">
            <button type="button" class="bill-pager__btn" [disabled]="!hasPrevPage" (click)="prevPage()">‹ Előző</button>
            <span class="bill-pager__pos">{{ page + 1 }} / {{ pageCount }}</span>
            <button type="button" class="bill-pager__btn" [disabled]="!hasNextPage" (click)="nextPage()">Következő ›</button>
        </span>
    </div>

</div>
